export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 — Find Products, QC & Buying Guide',
  'hero.h1': 'USFans Spreadsheet — Find Products, Check QC & Shop Smarter',
  'hero.subtitle': 'Explore the USFans Spreadsheet with practical guides, product categories, QC tips, shipping information, safety advice and the latest buying resources — all organized in one simple place.',
  'hero.usfansSpreadsheet': 'USFans Spreadsheet',
  'hero.buyNow': 'Buy It Now',
  'hero.startGuide': 'Start With the Beginner Guide',
  'hero.trust': 'Independent Resource • Updated Regularly • Multilingual',
  'hero.microcopy': 'Looking for USFans Spreadsheet links? Start here. Browse categories, understand QC, compare options and learn what to check before placing an order.',
  'hero.dropdownLabel': 'Choose a category to open',

  'categories.title': 'USFans Spreadsheet Categories',
  'categories.subtitle': 'Browse products by category and jump straight to the items you are looking for.',
  'categories.open': 'Open',

  'what.title': 'What Is the USFans Spreadsheet?',
  'what.body': 'The USFans Spreadsheet is a convenient way to discover and organize product links, categories and buying information. Instead of searching through scattered posts and links, our resource hub brings the most useful information into a structured, searchable experience.',
  'what.cta': 'Explore the Spreadsheet Guide',

  'guides.title': 'Everything You Need to Know About USFans',
  'guides.subtitle': 'Practical guides covering the topics buyers ask about most.',
  'guides.spread.title': 'USFans Spreadsheet',
  'guides.spread.desc': 'Find and understand spreadsheet resources.',
  'guides.review.title': 'USFans Review',
  'guides.review.desc': 'Learn what buyers should consider before using the platform.',
  'guides.shipping.title': 'USFans Shipping Cost',
  'guides.shipping.desc': 'Understand the factors that affect international shipping costs.',
  'guides.coupon.title': 'USFans Coupon',
  'guides.coupon.desc': 'Find out how coupons, promotions and discount codes work.',
  'guides.warehouse.title': 'USFans Warehouse',
  'guides.warehouse.desc': 'Understand storage, inspection and parcel preparation.',
  'guides.legit.title': 'Is USFans Legit?',
  'guides.legit.desc': 'Read our practical safety and legitimacy guide.',

  'why.title': 'Why Use Our USFans Spreadsheet Resource?',
  'why.item1': 'Easy-to-follow guides',
  'why.item2': 'Clear category navigation',
  'why.item3': 'QC education',
  'why.item4': 'Shipping explanations',
  'why.item5': 'Safety information',
  'why.item6': 'Comparison tables',
  'why.item7': 'Beginner-friendly tutorials',
  'why.item8': 'Regular content updates',

  'startHere.title': 'Start Here',
  'startHere.subtitle': 'New to USFans? Follow our beginner path:',
  'startHere.step1': 'Understand the USFans Spreadsheet',
  'startHere.step2': 'Find products',
  'startHere.step3': 'Check product information',
  'startHere.step4': 'Understand QC',
  'startHere.step5': 'Learn about shipping',
  'startHere.step6': 'Review safety considerations',
  'startHere.step7': 'Continue to the main website',
  'startHere.cta': 'Read the Complete USFans Beginner Guide',

  'safety.title': 'Safety First',
  'safety.body': 'A spreadsheet link is not a guarantee of product quality, seller reliability, payment security or delivery. Always verify information before ordering.',
  'safety.cta': 'Read the USFans Safety Guide',

  'teaser.title': 'Latest USFans Guides',
  'teaser.subtitle': 'Fresh, original guides written to help you buy smarter.',
  'teaser.category': 'Guide',
  'teaser.cardTitle': 'USFans Spreadsheet: Complete Guide to Finds, QC & Buying',
  'teaser.cardDesc': 'Learn what the USFans Spreadsheet is, how to use it, how to check QC, understand shipping and stay safe before you order.',
  'teaser.date': 'Updated August 2026',

  'faq.title': 'Frequently Asked Questions',
  'faq.q1': 'What is the USFans Spreadsheet?',
  'faq.a1': 'The USFans Spreadsheet is a structured resource that organizes product links, categories and buying information in one place. It helps buyers discover products faster instead of searching through scattered posts.',
  'faq.q2': 'How does the USFans Spreadsheet work?',
  'faq.a2': 'It groups products into categories and provides links, guides and checklists. You browse a category, review product information and QC details, then continue to the main website to place an order.',
  'faq.q3': 'Is USFans legit?',
  'faq.a3': 'Many buyers use USFans as a starting point for finding products, but a link alone does not guarantee quality or reliability. Always verify seller details, reviews and payment security before ordering.',
  'faq.q4': 'How much does USFans shipping cost?',
  'faq.a4': 'Shipping cost depends on package weight, destination and the shipping route you choose. Heavier parcels and faster routes cost more. Check the current rates on the main website before ordering.',
  'faq.q5': 'Does USFans offer coupons?',
  'faq.a5': 'Promotions and discount codes may appear from time to time. Check the main website and official channels for the latest offers, and always review conditions and expiration dates.',
  'faq.q6': 'What is the USFans warehouse?',
  'faq.a6': 'The warehouse is where products are stored, inspected and prepared for shipping. Understanding this process helps you know what happens to your order before it is sent.',
  'faq.q7': 'How do I check QC?',
  'faq.a7': 'QC (quality control) involves checking product photos, measurements and condition before shipping. Compare QC photos with the listing and ask questions if something looks unclear.',
  'faq.q8': 'Is this website officially affiliated with USFans?',
  'faq.a8': 'No. This is an independent informational resource and is not affiliated with, endorsed by, or sponsored by USFans. We provide helpful guides but do not sell products or handle orders.',

  'finalCta.title': 'Ready to Explore?',
  'finalCta.subtitle': 'Start with the USFans Spreadsheet, then use our guides to make better-informed decisions.',
  'finalCta.button': 'Explore USFans Spreadsheet',

  'pillars.title': 'Popular USFans Pillar Guides',
  'pillars.subtitle': 'In-depth guides covering the topics that matter most before you buy.',
  'pillars.readMore': 'Read More',
  'pillars.p1.title': 'USFans Spreadsheet Complete Guide',
  'pillars.p1.desc': 'Everything you need to know about finding products, checking QC and using the spreadsheet.',
  'pillars.p2.title': 'USFans Review',
  'pillars.p2.desc': 'What buyers should consider before using the platform.',
  'pillars.p3.title': 'USFans Shipping Cost Guide',
  'pillars.p3.desc': 'How weight, destination and route affect international shipping costs.',
  'pillars.p4.title': 'USFans Coupon Guide',
  'pillars.p4.desc': 'How coupons, promotions and discount codes work.',
  'pillars.p5.title': 'USFans Discount Code Guide',
  'pillars.p5.desc': 'Where to find and how to use discount codes safely.',
  'pillars.p6.title': 'USFans Warehouse Guide',
  'pillars.p6.desc': 'How storage, inspection and parcel preparation work.',
  'pillars.p7.title': 'Is USFans Legit?',
  'pillars.p7.desc': 'A practical look at safety and legitimacy before you order.',
  'pillars.p8.title': 'USFans Safety Guide',
  'pillars.p8.desc': 'How to avoid risks and shop with confidence.',
  'pillars.p9.title': 'USFans QC Guide',
  'pillars.p9.desc': 'How to read QC photos and check measurements.',
  'pillars.p10.title': 'USFans Buying Guide',
  'pillars.p10.desc': 'A step-by-step path from browsing to ordering.',
};